module.exports = __webpack_public_path__ + "static/media/filipstadvapen.1aeb0f5f.png";